import React from "react";
import { Link } from "react-router-dom";
import SectionTitle from "../../components/Common/SectionTitle";
import ProgressBar from "../../components/Elements/Progress/ProgressBar";

import aboutPart1 from "../../assets/img/about/about-part-1.jpg";
import aboutPart2 from "../../assets/img/about/about-part-1-2.jpg";
import aboutPart3 from "../../assets/img/about/about-part-1-3.png";

const About = (props) => {
  return (
    <div
      id="rs-about"
      className="rs-about pt-130 pb-190 md-pt-80 md-pb-80 sm-pt-0"
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-5 col-md-12">
            <div className="img-wrap">
              <img className="main" src={aboutPart1} alt="" />
              <div className="ly1">
                <img className="dance" src={aboutPart2} alt="" />
              </div>
              <div className="ly2">
                <img className="dance2" src={aboutPart3} alt="" />
              </div>
            </div>
          </div>
          <div className="col-lg-7 col-md-12 pl-40 md-pl-14 md-pt-240 sm-pt-66">
            {/* Section Title Start */}
            <SectionTitle
              sectionClass="sec-title mb-30"
              subtitleClass="sub-text"
              subtitle="About"
              titleClass="title pb-20"
              title="Building Long-Term Value Through Strategic Technology Partnerships"
              descClass="desc pr-90 md-pr-0"
              className="about-home"
              style={{
                textAlign: "justify",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
              }}
              description={
                <>
                  <p style={{ textAlign: "justify" }}>
                    We leverage our deep expertise in IT services to craft innovative software
                    applications and mobile experiences that empower businesses globally.
                  </p>
                  <p style={{ textAlign: "justify" }}>
                    We believe technology should be a catalyst for positive change. At TAVS, we
                    tackle complex business challenges with tailored IT solutions. From custom
                    software development to strategic consulting, we help organizations optimize
                    processes and achieve their goals. Recognizing the critical role of human
                    capital, our flagship product 'PAPA - Perform Achieve Progress Ascend', an
                    employee performance management platform designed to cultivate talent and
                    drive organizational success.
                  </p>
                  <p>We specialize in the following areas:</p>
                </>
              }
            />

            {/* Section Title End */}
            <div className="row">
              <div className="col-lg-10">
                {/* Skill Bar Start */}
                <div className="rs-skillbar style1">
                  <p></p>
                  <ul class="beautiful-list">
                    <li>
                      <i class="pi pi-desktop"></i> Software Development
                    </li>
                    <li>
                      <i class="pi pi-mobile"></i> App Development
                    </li>
                    <li>
                      <i class="pi pi-brain"></i> Artificial Intelligence
                    </li>
                    <li>
                      <i class="pi pi-globe"></i> Web Development
                    </li>
                  </ul>
                </div>
                {/* Skill Bar End */}
                <div className="btn-part mt-54">
                  <a
                    href="#rs-service"
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector("#rs-service")?.scrollIntoView({ behavior: "smooth" });
                    }}
                    className="readon learn-more"
                  >
                    Learn More
                  </a>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
